module.exports = __webpack_public_path__ + "static/media/hsv_triangle_mask.9d4466bc.png";